<div style="padding-top: 10px; width: 'width';">
  <figure id="bar"></figure>
</div>
